module.exports = __webpack_public_path__ + "img/Lorraine.c52feb73.jpg";